
export class ViaType {
    id: number;
    viaTypeName: string;
    status: boolean;
}